import IZoningCodeVersion = ZoningAPI.IZoningCodeVersion;
import IZoningCodeCalculationStatistic = ZoningAPI.IZoningCodeCalculationStatistic;
import IZoningCodeVersionMetaData = ZoningAPI.IZoningCodeVersionMetaData;

import { ClonableItem } from '../../../shared/models/clonable-item';
import * as _ from 'lodash';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

export class ZoningCodeVersion extends ClonableItem<IZoningCodeVersion> implements IZoningCodeVersion {
    Id: number;
    ZoningCodeId: number;
    ActualVersion: number;
    PRCalculationResultsCount?: number;
    GridicsId?: string;
    OldGridicsId?: number;
    MetaData?: IZoningCodeVersionMetaData;
    createdAt: string;
    updatedAt: string;

    Tasks: ITaskModel[] = [];
    Statistic: IZoningCodeCalculationStatistic[] = [];
    isDeleting?: boolean;

    constructor(data) {
        super(data);
        this.PRCalculationResultsCount = this.PRCalculationResultsCount || 0;
    }

    get CalculationTask() {
        return this.Tasks.find(task => task.isCalculation);
    }

    updateTasksFromList(tasks: ITaskModel[] = []) {
        this.Tasks = tasks.filter(task => task.zcVersionId === this.Id && task.zcGridicsId === this.GridicsId);
        this.PRCalculationResultsCount = _.get(this, 'Tasks[0].totalPropertyRecords', this.PRCalculationResultsCount);
    }

    get hasTasksOrStatistics(): boolean {
        return !!this.Tasks.length || !!this.Statistic.length;
    }

    get taskOrStatistic(): ITaskModel | IZoningCodeCalculationStatistic {
        return this.Tasks.length ? this.Tasks[0] : this.Statistic[0];
    }

    setDeletionStatus(status: boolean) {
        this.isDeleting = status;
    }

    resetPRCalculationResultsCount() {
        this.PRCalculationResultsCount = 0;
    }

    get hasTasks(): boolean {
        return !!this.Tasks.length;
    }

    setStatistic(statistic: IZoningCodeCalculationStatistic) {
        this.PRCalculationResultsCount = statistic.totalPropertyRecords;
        this.Statistic[0] = statistic;
    }
}

export function ZoningCodeVersionFactory(data: IZoningCodeVersion) {
    return new ZoningCodeVersion(data);
}
